export enum UnifiedExportEvent {
    Add = 'ExportPage.Add',
    EditConnection = 'ExportPage.EditConnection',
    Filter = 'ExportPage.Filter',
    CreateConnection = 'ExportPage.CreateConnection',
    TestConnectionDrawer = 'ExportPage.TestConnection.Drawer',
    TestConnectionTable = 'ExportPage.TestConnection.Table',
    AddConnection = 'ExportPage.AddConnection',
}
